<script>
  import { createRandomCleanEncoding } from "bitframes";
  import StaticArtwork from "./StaticArtwork.svelte";
  import { onMount } from "svelte";
  import { withIntersection } from "../util/with-intersection.js";

  let encoding;
  refresh();

  let idealWidth = 2048;

  let container;
  let interval;
  resize();
  onMount(() => {});

  function start() {
    stop();
    interval = setInterval(refresh, 1000);
  }

  function refresh() {
    encoding = createRandomCleanEncoding(undefined, { system: 1 });
  }

  function stop() {
    clearInterval(interval);
  }

  function onVisibility(visible) {
    if (visible) start();
    else stop();
  }

  function resize() {
    idealWidth =
      window.innerWidth * window.devicePixelRatio > 2048 ? 4096 : 2048;
  }
</script>

<svelte:window on:resize|passive={resize} />
<div
  class="container noselect"
  bind:this={container}
  use:withIntersection={{
    onChange: (visible) => onVisibility(visible),
  }}
  role="none"
  on:click={(ev) => {
    ev.preventDefault();
    refresh();
    start();
  }}
>
  <StaticArtwork
    canvasResolution={idealWidth}
    zoom
    lazyRender={true}
    displayPadding={0}
    {encoding}
  />
</div>

<style>
  .cell {
    /* width: 256px; */
    /* height: 256px; */
  }
  .view-all-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .container {
    cursor: pointer;
    overflow: hidden;

    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  /* .half { */
  /* max-width: 50vw; */
  /* } */
  .header {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .gallery {
    /* margin-top: 20px; */
    /* margin-bottom: 20px; */
    flex-grow: 1;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0px;
    /* flex-wrap: wrap; */
    /* flex-flow: wrap; */

    /* grid-template-columns: repeat(auto-fit, minmax(128px, 1fr)); */

    /* grid-template-columns: repeat(2, 1fr); */
    grid-template-columns: repeat(3, minmax(32px, 1fr));
    /* grid-template-rows: repeat(2, 1fr); */
    display: grid;
    grid-gap: var(--gap);
    box-sizing: border-box;
  }
  .cell {
    /* aspect-ratio: 1; */
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    /* cursor: pointer; */
  }

  @media screen and (max-width: 720px) {
    .container {
      max-width: initial;
      /* height: calc(max(300px, min(50vh, 500px))); */
      /* height: initial; */
      /* width: 100%; */
      /* padding: 20px; */
      --gap: 10px;
      /* --columns: 2; */
    }
    .gallery {
      /* margin: 0; */
    }
  }
</style>
